const FOOTER = {
    GITHUB_URL: "https://github.com/elenaek",
    LINKEDIN_URL: "https://www.linkedin.com/in/keanele/",
    BLOG_URL: "https://keanele.io",
    BUSINESS_PHONE_NUMBER: "+1 123-456-7890",
    BUSINESS_EMAIL: "keane.le@keane.io",
    MAILTO_SUBJECT: "Business%20Query"
}

export default FOOTER;